import * as React from "react";
const SvgVerticalSeparator = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 2 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, width: 1, height: 16, rx: 0.5, fill: "currentColor" }));
export default SvgVerticalSeparator;
